export enum Defaults {
    SnackBarInfoDuration = 2000,
    SnackBarErrorDuration = 5000,
    DialogOpenDuration = 300,
    DialogCloseDuration = 300,
}
